// Auto-generated by generateRolePools.ts — do not edit manually
import poolsData from './championRolePools.json';

export interface RolePools {
  top: string[];
  jungle: string[];
  mid: string[];
  bot: string[];
  support: string[];
  generatedAt: string;
}

const rolePools: RolePools = poolsData;
export default rolePools;
